import script from "./MainNav.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNav.vue?vue&type=script&setup=true&lang=js"

import "./MainNav.vue?vue&type=style&index=0&id=545689bf&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/inticons/inticons/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545689bf"]])

export default __exports__